import axios from "axios";
import store from "../store";
import router from "../router";
import Qs from "qs";
import { Message } from "element-ui";
import { getStorage } from "@/utils/auth";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  responseType: "json",
  timeout: 10000, // 请求超时时间 单位：毫秒
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// request 拦截器
service.interceptors.request.use(
  (config) => {
    // 根据api统一规则拼接url
    config.url = config.baseURL + config.path;
    // 无需token的接口白名单
    const notStorage = ["auth/login"];
    if (notStorage.indexOf(config.path) < 0) {
      // 设置token参数
      //config.headers.Authorization = getToken("token");
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// respone 拦截器
service.interceptors.response.use(
  (response) => {
    // const res = JSON.parse(Base64.decode(response.data.body))
    const res = response.data;
    if (res.code === 1001 || res.code === 1002 || res.code === 1003) {
      // 操作失败
      Message({
        message: res.msg,
        type: "error",
        duration: 5 * 1000,
      });
      // 重定向到登录页
      store.dispatch("Logout").then(() => {
        // 跳转到登录页
        router.replace({
          path: "/login",
        });
      });
      return Promise.reject(res.msg);
    } else if (res.code === 400) {
      // 无权限
      // 跳转到403页面
      router.replace({
        path: "/403",
      });
      return Promise.reject(res.msg);
    } else if (res.code === 1 || res.code === "1") {
      // 操作失败
      Message({
        message: res.msg,
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(res.msg);
    } else {
      // 请求成功
      // console.log(res)
      return res;
    }
  },
  (error) => {
    const originalRequest = error.config;
    let _errText = "错误信息：";
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1 &&
      !originalRequest._retry
    ) {
      _errText += "请求超时";
    } else {
      _errText += "请求失败";
    }
    Message({
      message: _errText,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
